// src/lib/locationHelpers.js

/**
 * Handles all location logic for city/coords mode:
 * - validates place / lat / lon
 * - returns field errors + final location payload (city/country or lat/lon)
 *
 * birthDetails: { placeName, lat, lon }
 * form: { country }
 * locationMode: "city" | "coords"
 */
export function validateAndBuildLocation({ birthDetails, form, locationMode }) {
  const errors = {
    placeName: "",
    lat: "",
    lon: "",
    topMessage: "",
  };

  const countryStr = (form.country || "").trim();
  const placeStr = (birthDetails.placeName || "").trim();
  const latStr = (birthDetails.lat ?? "").toString().trim();
  const lonStr = (birthDetails.lon ?? "").toString().trim();

  const hasPlace = placeStr.length > 0;
  const hasLatLon = latStr !== "" && lonStr !== "";

  let locationPayload = null;

  if (locationMode === "city") {
    if (!hasPlace) {
      errors.placeName = "Please enter place of birth.";
    }

    if (!countryStr) {
      errors.topMessage = "Please enter country.";
    }

    if (!errors.placeName && !errors.topMessage) {
      const cityFromPlace = placeStr.split(",")[0];
      locationPayload = {
        city: cityFromPlace,
        country: countryStr || "India",
      };
    }
  } else if (locationMode === "coords") {
    if (!hasLatLon) {
      if (!latStr) errors.lat = "Latitude is required.";
      if (!lonStr) errors.lon = "Longitude is required.";
    } else {
      const latNum = Number(latStr);
      const lonNum = Number(lonStr);

      if (Number.isNaN(latNum) || latNum < -90 || latNum > 90) {
        errors.lat = "Latitude must be between -90 and 90.";
      }

      if (Number.isNaN(lonNum) || lonNum < -180 || lonNum > 180) {
        errors.lon = "Longitude must be between -180 and 180.";
      }
    }

    if (!errors.lat && !errors.lon) {
      // 🔴 use 'latitude' / 'longitude' to match backend
      locationPayload = {
        latitude: Number(latStr),
        longitude: Number(lonStr),
        country: countryStr || "India",
      };
    }
  }

  return { errors, locationPayload };
}
